import { render, staticRenderFns } from "./AsyncCard.vue?vue&type=template&id=3c46dcd3&scoped=true"
import script from "./AsyncCard.vue?vue&type=script&lang=js"
export * from "./AsyncCard.vue?vue&type=script&lang=js"
import style0 from "./AsyncCard.vue?vue&type=style&index=0&id=3c46dcd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46dcd3",
  null
  
)

export default component.exports